import cn from '@/utils/cn';

import { Combobox } from '@headlessui/react';

interface Props {
  item: {
    label: string;
    value: number | string;
  };
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  'data-testid'?: string;
}

const OptionItem: React.FC<Props> = ({
  item,
  className,
  onClick,
  children,
  'data-testid': dataTestId,
}) => {
  return (
    <Combobox.Option
      value={item?.label}
      onClick={onClick}
      data-testid={dataTestId || `${item?.label}-option`}
      className={() =>
        cn(
          'relative flex cursor-pointer select-none items-center rounded-lg px-2 py-[3px] outline-none',
          "transition-colors data-[state='checked']:font-semibold hover:bg-gray-200 focus:bg-gray-200 focus:outline-none",
          className
        )
      }
    >
      <p className={cn('text-oxford-blue-500')}>{children ?? item?.label}</p>
    </Combobox.Option>
  );
};
export default OptionItem;
